import { Button, Stack, Typography } from "@mui/material";
import WhiteCard from "../WhiteCard";
import { Add } from "@mui/icons-material";
import { useGetProviderEPrescribeServicesQuery } from "src/api/services/providersApi";
import { useGetClinicianRegistrationStatusQuery } from "src/api/services/ePrescribeApi";
import { skipToken } from "@reduxjs/toolkit/query";
import { useManageModal } from "src/hooks/useManageModal";
import AddEPrescribeClinicianModal from "../Modals/AddEPrescribeClinicianModal";
import { useClinician } from "src/context/SessionProvider/ClinicianProvider";
import { DetailedEmployee } from "src/api/types";

interface Props {
  user: DetailedEmployee;
}

const ProviderEPrescribe = ({ user }: Props) => {
  const [open, { handleClose, handleOpen }] = useManageModal();
  const { data } = useGetProviderEPrescribeServicesQuery({
    employeeId: user.id,
    serviceName: "Dosespot",
  });

  const allowCreation = useClinician((c) =>
    c.roles.some((role) => ["Operations", "Developer"].includes(role.name)),
  );

  const { status } = useGetClinicianRegistrationStatusQuery(
    data != null ? Number(data.external_id) : skipToken,
    {
      selectFromResult: ({ data }) => {
        return { status: data?.status ?? "N/A" };
      },
    },
  );

  return (
    <>
      <WhiteCard gap={1} sx={{ overflowY: "auto" }}>
        <Stack gap={1}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="subtitle2">
              PROVIDER E-PRESCRIBE INFO
            </Typography>
            {allowCreation ? (
              <Button
                variant="text"
                sx={{ alignSelf: "start" }}
                onClick={handleOpen}
                startIcon={<Add />}
              >
                Create
              </Button>
            ) : null}
          </Stack>

          <Stack>
            {data == null ? (
              <Typography>
                Provider is not connected to any E-Prescribe services at this
                time
              </Typography>
            ) : (
              <Stack key={data.id}>
                <Typography>Name: {data.pharmacy.name}</Typography>
                <Typography>External Id: {data.external_id}</Typography>
                <Typography>Registration Status: {status}</Typography>
              </Stack>
            )}
          </Stack>
        </Stack>
      </WhiteCard>
      <AddEPrescribeClinicianModal
        onClose={handleClose}
        open={open}
        user={user}
      />
    </>
  );
};

export default ProviderEPrescribe;
